/// <reference path="../../../tools/typings/tsd.d.ts"/>


namespace DealerwareWebServices {
    "use strict";

    export interface IInterceptor {
        request: Function;
        //requestError: Function;
        //response: Function;
        responseError: Function;
    }

    export class HttpInterceptor implements IInterceptor {

        public static $inject   : string[]  =   [
            '$q',
            '$location',
            'MobilityAuthenticationStrategy',
            'loginPath',
            'AppConfig'
        ];

        public defer : ng.IDeferred<any>;

        constructor(
            private $q          : ng.IQService,
            private $location   : ng.ILocationService,
            private auth        : any,
            private loginPath   : string,
            private appConfig   : any
        ) {
            this.defer = this.$q.defer();
        }

        public isApiRequest = ( config: any ) => {
            return config.url
                && config.headers.Accept
                && config.headers.Accept.indexOf('application/json') !== -1;
        }

        public request = (config: any) : ng.IPromise<any> => {
            // Put API version headers on API requests only.
            if (this.isApiRequest(config)) {
                if (config.headers['Api-Version'] === undefined) {
                    config.headers['Api-Version'] = '3';
                }
            }

            config.headers['App-Name'] = "Dealerware";
            config.headers['App-Version'] = this.appConfig.version;
            config.headers['Platform'] = "Web";

            return config;
        }

        public responseError = (responseFailure: any) : ng.IPromise<any> => {

            // This is a handled response.  Since RESTfully, we can get back a 404
            // when we legitimately ask for a non-existent resource via a correct
            // endpoint path, we'll decorate the error response with a flag that lets
            // an inquiring service know that an API request has comne back as 404,
            // which in the case of a rake route-compliant application which we should have,
            // allows the catch block to formulate an appropriate empty object resopnse and
            // not turn on the warning claxons and show errors to the user which
            // a non-2xx response would usually generate.
            //
            if (responseFailure.status === 404 && this.isApiRequest(responseFailure.config)) {
                responseFailure.apiResourceNotFound = true;
            }
            else if (responseFailure.status === 401 && this.$location.path() !== this.loginPath) {
                this.auth.clearAuthenticationCredentials();
                this.$location.path(this.loginPath);
            }

            return this.$q.reject(responseFailure);
        }
    }

    getDealerwareWebServicesModule().service('$dealerwareHttpInterceptor', HttpInterceptor);
}
